import { useContext } from 'react'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import useSeti from './useSeti'

export default function useCityNameInFormHeadlineForSEMFlights() {
  const { prePopData } = useContext(BootstrapDataContext)
  const cityName = prePopData?.flights?.flights?.[0]?.endLocation?.cityName
  const FLIGHTS_LP_SEM_CITY_HEADING = useSeti(
    'FLIGHTS_LP_SEM_CITY_HEADING',
    !!cityName
  )
  return FLIGHTS_LP_SEM_CITY_HEADING === 'VARIANT' && !!cityName
    ? `Fly to ${cityName} with confidence`
    : ''
}
